var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHowItWorksIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 41,
  viewBox: "0 0 45 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 41,
  rx: 8,
  fill: "#E60000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5863 24.4755V23.6939C20.5863 21.5647 21.3949 20.217 22.9851 18.9772C24.2519 17.98 24.8988 17.4679 24.8988 16.1202C24.8988 14.53 24.0902 13.6945 22.6078 13.6945C20.8289 13.6945 19.8317 15.0691 19.8317 17.1983H15.8696C15.9505 13.2363 18.5649 10.541 22.4191 10.541C27.4054 10.541 29.1303 13.6136 29.1303 15.7698C29.1303 18.4921 27.8097 19.5971 26.7855 20.3518L25.896 20.9987C24.9257 21.6994 24.225 22.5619 24.225 23.6939V24.4755H20.5863ZM22.3652 30.459C21.1254 30.459 20.0473 29.4618 20.0473 28.195C20.0473 26.9013 21.1254 25.904 22.3383 25.904C23.5781 25.904 24.6023 26.9552 24.6023 28.195C24.6023 29.354 23.5511 30.459 22.3652 30.459Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHowItWorksIcon);
export default ForwardRef;